import { render, staticRenderFns } from "./BaseEtymVarAutocomplete.vue?vue&type=template&id=e1fb434a&"
import script from "./BaseEtymVarAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseEtymVarAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports